import React from "react";
import { Phone, MessageCircle } from "lucide-react";
import { waLink, telLink } from "../lib/contact";

export default function FloatingActions() {
  return (
    <div className="fixed right-4 md:right-6 bottom-24 md:bottom-8 z-40 hidden md:flex flex-col gap-3" data-testid="floating-actions">
      <a
        href={waLink()}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="WhatsApp"
        data-testid="fab-whatsapp"
        className="relative w-14 h-14 rounded-full bg-emerald-500 hover:bg-emerald-600 text-white flex items-center justify-center shadow-2xl shadow-emerald-500/40 animate-pulse-ring transition-transform hover:scale-105"
      >
        <MessageCircle className="w-6 h-6" />
      </a>
      <a
        href={telLink()}
        aria-label="Call now"
        data-testid="fab-call"
        className="relative w-14 h-14 rounded-full bg-blue-600 hover:bg-blue-700 text-white flex items-center justify-center shadow-2xl shadow-blue-500/40 animate-pulse-ring-blue transition-transform hover:scale-105"
      >
        <Phone className="w-6 h-6" />
      </a>
    </div>
  );
}
